import React, { useState, useEffect } from 'react'
import 'animate.css'
import { Row, Col } from 'antd'

import { httpClient } from 'core/util/httpClient'
import { service } from 'core/schemas'

import CardInfo from 'components/CardInfo'
import ScrollUpBtn from 'components/ScrollUpBtn'
import DetailContact from 'components/DetailContact'

import { Container, Title, CardContainer } from './serviceSUT.style'

const ServiceSUT = () => {
  const [serviceData, setServiceData] = useState([])
  const [contactData, setContactData] = useState([])

  useEffect(() => {
    window.scrollTo(0, 0)
    
    getDataService()
    getDataContact()
  }, [])

  const getDataService = async () => {
    const response = await httpClient.get(service)

    if (response?.data?.code === 200) {
      const data = response?.data?.data

      setServiceData(data)
    } else {
      setServiceData([])
    }
  }
  const getDataContact = async (id) => {
    const response = await httpClient.get(
      `institute/branch_contract?course=996`,
    )

    if (response?.data?.code === 200) {
      const data = response?.data?.data

      setContactData(data)
    } else {
      setContactData([])
    }
  }

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className='animate__animated animate__flipInX animate__slow'>
              การให้บริการมหาวิทยาลัย
            </Title>
          </Col>
        </Row>

        <CardContainer>
          {serviceData.length >= 0 &&
            serviceData.map((item, index) => {
              const textEN = item?.nameEN.split(' ')

              return (
                <CardInfo
                  key={index}
                  src={item?.image}
                  name={item?.nameTH}
                  titleImage={textEN[0]}
                  nameImage={textEN[1]}
                  cursor='false'
                  link={item?.link}
                />
              )
            })}
        </CardContainer>

        {contactData && (
          <Row gutter={24} className='row-contact'>
            {contactData.length > 1 &&
              contactData.map((item, index) => {
                return (
                  <Col span={8} style={{ padding: '10px' }} key={index}>
                    <div style={{ marginBottom: '5px' }}>
                      <DetailContact
                        color='var(--black)'
                        title={item?.title}
                        phone={item?.phone_1}
                        office={item?.phone_2}
                        facebook={item?.fb}
                        website={item?.site}
                        email1={item?.email_1}
                        email2={item?.email_2}
                        line={item?.line}
                        address={item?.address}
                        indentAddress={'40'}
                        indent={'40'}
                        type='branch'
                        titleWebsite="เว็บไซต์"
                      />
                    </div>
                  </Col>
                )
              })}
          </Row>
        )}
      </Container>

      <ScrollUpBtn />
    </>
  )
}

export default ServiceSUT
